import { render } from "./jydt.vue?vue&type=template&id=a2a601c6&scoped=true"
import script from "./jydt.vue?vue&type=script&lang=js"
export * from "./jydt.vue?vue&type=script&lang=js"

import "./jydt.vue?vue&type=style&index=0&id=a2a601c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2a601c6"]])

export default __exports__